import useTravelModeContext from '@contexts/travelModeContext'
import { colors, fontSize, size } from '@styles/theme'
import { useAuthContext } from '@contexts/authContext'
import styled from '@emotion/styled'
import { PiCrosshairBold, PiProhibitBold } from 'react-icons/pi'
import { ButtonBase } from '@mui/material'

const TagetIndicatorContainer = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 100;

  display: flex;
  align-items: center;
  justify-content: center;

  height: 2rem;
  width: 2rem;

  transform: translate(-50%, -50%);
  border: 3px solid ${colors.statusColors.right_now('primary')};
  border-radius: 100px;
  background-color: black;
`

const TranslucentRadius = styled.div`
  position: absolute;
  height: ${size(7)};
  width: ${size(7)};
  background-color: ${colors.statusColors.right_now('primary')};
  border-radius: 100px;
  opacity: 0.2;
`

const SetNewLocationButton = styled(ButtonBase)`
  position: absolute;
  top: ${size(-9)};
  padding: ${size(2.5)};
  background-color: ${colors.statusColors.right_now('primary')};
  border-radius: 100px;
  font-weight: bold;
  white-space: nowrap;
`

const BtnCaret = styled.div`
  position: absolute;
  bottom: ${size(-1)};

  height: ${size(2)};
  width: ${size(2)};

  background-color: ${colors.statusColors.right_now('primary')};
  transform: rotate(45deg);
`

const ProfileCountContainer = styled.div`
  position: absolute;
  bottom: ${size(-7)};

  padding: ${size(1)} ${size(2)};
  background-color: rgba(0,0,0,0.5);
  border-radius: 100px;
  
  font-size: ${fontSize('xs')};
  white-space: nowrap;
`

const ClearTravelButton = styled(ButtonBase)`
  position: absolute;
  top: ${size(-12.5)};
  padding: ${size(0.75)} ${size(1.25)};
  background-color:  ${colors.error(500)};
  border-radius: 100px;
  font-size: ${fontSize('xs')};
  font-weight: 500;
  white-space: nowrap;
`

const TravelModeTargetIndicator = () => {
  const { state: authState } = useAuthContext()
  const {
    isTravelModeSelectorEnabled,
    isLoadingNearbyPositionsDelayed,
    isLoadingNearbyUsers,
    nearbyProfileCount,
    setNewLocation,
    clearTravelMode,
  } = useTravelModeContext()

  const renderNearbyProfileCount = () => {
    if (isLoadingNearbyUsers) {
      return 'loading nearby users...'
    } else if (typeof nearbyProfileCount === 'number' && !isLoadingNearbyPositionsDelayed) {
      return `${nearbyProfileCount >= 200 ? '200+' : nearbyProfileCount} nearby users`
    } else {
      return 'checking profiles...'
    }
  }

  if (isTravelModeSelectorEnabled) return (
    <TagetIndicatorContainer>
      {authState?.user?.travelModeEnabledAt &&
        <ClearTravelButton
          disabled={isLoadingNearbyUsers}
          onClick={clearTravelMode}>
          <PiProhibitBold />
          &nbsp;Return Home
        </ClearTravelButton>
      }
      <TranslucentRadius />
      <PiCrosshairBold />
      <SetNewLocationButton
        disabled={isLoadingNearbyUsers}
        onClick={setNewLocation}>
        Set New Location
        <BtnCaret />
      </SetNewLocationButton>
      <ProfileCountContainer>
        {renderNearbyProfileCount()}
      </ProfileCountContainer>
    </TagetIndicatorContainer>
  )
}

export default TravelModeTargetIndicator
